
import { useSelector  } from 'react-redux';

import { getDatawin } from '../reducers'
import { getDataModelItemId } from '../reducers/datawin'

export default function useDatawinDataModelItemId() {
    const datawin = useSelector(state => getDatawin(state.data));
    return getDataModelItemId(datawin);
}
